/* eslint-disable unicorn/no-await-expression-member */

import { SidePanel } from '@dev-spendesk/grapes';

import { RequestCreationPanelSkeleton } from 'modules/requests/components/RequestCreationPanelSkeleton';
import { EmptyStateError, lazyLoad } from 'src/core/common/components/LazyLoad';

export const LazyRequestsPanel = lazyLoad({
  loader: async () => ({
    default: (
      await import(
        /* webpackChunkName: "RequestsPanel", webpackPrefetch: true */ '../../../list/components/RequestPanelContainer'
      )
    ).RequestPanelContainer,
  }),
  loading: <RequestCreationPanelSkeleton entriesCount={3} />,
  fallback: (props) => (
    <SidePanel>
      <EmptyStateError {...props} />
    </SidePanel>
  ),
});
